module.exports = __webpack_public_path__ + "img/blog-68.1d9caa0f.jpg";